import axios from 'axios'
import { stringify } from 'qs'

import cache from 'modules/core/lib/mobx-rest-cache'

import buildFormData from './buildFormData'

type Method = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
type ResponseType = 'arraybuffer' | 'document' | 'json' | 'text' | 'stream' | 'blob'
interface Options {
  method: Method
  headers?: { [key: string]: string } | null
  withCredentials?: boolean
  data?: { [key: string]: any } | null
  responseType?: ResponseType
}

function ajaxOptions(options: Options): {} {
  const headers = { ...options.headers }

  const baseOptions = {
    headers,
    method: options.method,
    withCredentials: options.withCredentials,
    ...(options.responseType && { responseType: options.responseType }),
  }

  if (options.method === 'GET') {
    return baseOptions
  } else {
    const { hasFile, formData } = buildFormData(options.data)

    if (hasFile) {
      return {
        ...baseOptions,
        data: formData,
      }
    } else {
      return {
        ...baseOptions,
        data: options.data,
      }
    }
  }
}

function ajax(url: string, options: Options): Promise<any> {
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  return axios({
    url,
    cancelToken: source.token,
    ...ajaxOptions(options),
  }).then((response) => response.data)
}

export default {
  apiPath: '',
  commonOptions: {},

  get(path: string, data?: {}, options: {} = {}): Promise<any> {
    const baseUrl = `${this.apiPath}${path}`

    const url = Object.entries(data || {}).length
      ? `${baseUrl}?${stringify(data, { arrayFormat: 'brackets' })}`
      : baseUrl

    return ajax(url, {
      method: 'GET',
      ...this.commonOptions,
      ...options,
    })
  },

  post(path: string, data?: {}, options: {} = {}): Promise<any> {
    return ajax(`${this.apiPath}${path}`, {
      method: 'POST',
      data,
      ...this.commonOptions,
      ...options,
    })
  },

  put(path: string, data?: {}, options: {} = {}): Promise<any> {
    return ajax(`${this.apiPath}${path}`, {
      method: 'PUT',
      data,
      ...this.commonOptions,
      ...options,
    })
  },

  patch(path: string, data?: {}, options: {} = {}): Promise<any> {
    return ajax(`${this.apiPath}${path}`, {
      method: 'PATCH',
      data,
      ...this.commonOptions,
      ...options,
    })
  },

  del(path: string, data?: {}, options: {} = {}): Promise<any> {
    return ajax(`${this.apiPath}${path}`, {
      method: 'DELETE',
      data,
      ...this.commonOptions,
      ...options,
    })
  },

  cache,
}
